<template>
  <div style="padding-bottom: 80px;" v-loading="loading">
    <div class="box">
      <div class="box-label" style="font-weight:800">盡職審查</div>
      <div class="formbox">
        <div class="box-row">
          <reviewlistcom  v-if="!loading" :disabled="isReadonly" :showType="form.ordertype+1" :showData="form.inspect" :resultData.sync="inspect"></reviewlistcom>
        </div>
      </div>
    </div>

    <div class="box">
      <div class="box-label">
        <div style="font-weight:800">合規主任專用</div>
        <div>
          <el-button @click="dialogeditremark=true">添加備註</el-button>
        </div>
      </div>
      <div class="form-isheader-group">
        <div class="form-isheader-group-content">
          <div class="mm-row">
            <div class="mm-col">
              <div class="mm-item">
                <div class="mm-label">風險評分:</div>
                <el-switch v-model="form.risk" @change="setrisk(form.risk,'risk')" active-value="1" inactive-value="0" active-color="#ff4949" inactive-color="#e6e6e6" active-text="高風險" inactive-text="低風險"></el-switch>
              </div>
            </div>
            <div class="mm-col">
              <div class="mm-item">
                <div class="mm-label">懷疑個案:</div>
                <el-switch v-model="form.doubt" @change="setrisk(form.doubt,'doubt')" active-value="1" inactive-value="0" active-color="#ff4949" inactive-color="#e6e6e6" active-text="是" inactive-text="否"></el-switch>
              </div>
            </div>
            <div class="mm-col">
              <div class="mm-item">
                <div class="mm-label">舉報個案:</div>
                <el-switch v-model="form.impeach" @change="setrisk(form.impeach,'impeach')" active-value="1" inactive-value="0" active-color="#ff4949" inactive-color="#e6e6e6" active-text="是" inactive-text="否"></el-switch>
              </div>
            </div>
          </div>
          <div class="pagemain">
            <div class="pagetablebox">
              <el-table :data="data" border :header-cell-style="{background:'#FAFAFA'}">
                <el-table-column property="holder" label="合規主任">
                  <template slot-scope="scope">
                    <div class="phonecel">水單</div>
                    <div>{{scope.row.holder}}</div>
                  </template>
                </el-table-column>
                <el-table-column property="addtime" label="時間">
                  <template slot-scope="scope">
                    <div class="phonecel">時間</div>
                    <div>{{scope.row.addtime}}</div>
                  </template>
                </el-table-column>
                <el-table-column property="content" label="備注">
                  <template slot-scope="scope">
                    <div class="phonecel">備注</div>
                    <div>{{scope.row.content}}</div>
                  </template>
                </el-table-column>
                <el-table-column property="files" label="附件">
                  <template slot-scope="scope">
                    <div class="phonecel">附件</div>
                    <template v-for="(item,index) in scope.row.files">
                      <span :key="index">
                        <img :src="apiurl+item.fileurl" height="35px" class="tableimg mr10" @click="showimg_url=apiurl+item.fileurl;showimg_dialog = true;">
                      </span>
                    </template>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 添加合規主任紀錄 -->
    <el-dialog :visible.sync="dialogeditremark" width="90%" :append-to-body="true" :close-on-click-modal="false" top="5vh">
      <remarkcom @submit="getdata" v-if="dialogeditremark" :order_id="order_id" :isReadonly="false" :showData="showdata" :visible.sync="dialogeditremark" :title="'添加備註'"></remarkcom>
    </el-dialog>
    <!-- 圖片查看 -->
    <el-dialog :visible.sync="showimg_dialog" :append-to-body="true" height="80%" center top="5vh">
      <img :src="showimg_url" alt="" style="width:100%;margin:0 auto;">
    </el-dialog>
  </div>
</template>

<script>
import reviewlistcom from "@/components/ReviewList.vue";
import remarkcom from "./Remark.vue";
export default {
  components: {
    reviewlistcom,
    remarkcom
  },
  props: ['order_id','store_id'],
  data () {
    return {
      loading:true,
      dialogeditremark: false,
      showimg_dialog: false,
      showimg_url: "",
      showdata: {},
      data: [],
      showpage: false,
      value: '',
      showpicurl: '',
      showpicbox: false,
      isReadonly: true,
      files: [],
      form: {},
      inspect: {},
    };
  },
  methods: {
    setrisk (value, field) {
      let staff_id = sessionStorage.getItem('staff_id');
      let store_id = this.store_id;
      let id = this.order_id;
      this.loading = true;
      this.post('/api/order/setrisk', {
        id,
        value,
        field,
        staff_id,
        store_id
      }).then(response => {
        this.loading = false;
        if (response.status == 'success') {
          this.$notify({
            showClose: true,
            message: '修改成功！',
            type: 'success',
            offset: 80,
          });
          this.init();
        } else {
          this.$notify({
            showClose: true,
            message: '修改失敗，請重試！',
            type: 'error',
            offset: 80
          });
        }
      }).catch(error => {
        this.loading = false;
        console.log(error);
      })
    },
    getdata () {
      this.post('/api/order/review_info', {
        order_id: this.order_id
      }).then((res) => {
        if (res.id) {
          this.inspect = res.inspect;
          this.form = res;
          this.data = res.director_remark;
          this.loading = false;
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    delpic (file, fileList) {

    },
    viewpic (file) {
      this.showpicurl = file.url;
      this.showpicbox = true;
    }
  },
  created () {
    this.getdata();
  }
};
</script>

<style scoped>
.profit_title h3 {
  color: #333;
  border-bottom: 1px solid #dcdfe6;
  padding: 20px 0;
}

.profit_contentbox {
  padding: 20px 0;
}

.mm-row {
  padding: 10px;
}

.mm-item {
  display: flex;
  align-items: center;
}

.formbox {
  background: #fafafa;
  min-height: 200px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}
.box-row {
  display: flex;
  align-items: center;
  padding: 20px;
}
.box-label {
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.box-title {
  flex: 0 50%;
}
.filesbox {
}
@media screen and (max-width: 1024px) {
  .mm-row {
    display: block;
  }
  .el-input__suffix {
    position: absolute !important;
    top: 0px !important;
  }
}
</style>
